// Broadway Theater Productions Dataset
// Productions at 20 major Broadway theaters from 2017 to 2025
// Resources are the theaters, events are individual production runs from opening to closing night
// Note: All Broadway theaters were closed from March 12, 2020 to approximately September 2021 due to COVID-19

export const defaultVisibleDate = new Date('2022-01-01T00:00:00');

export const resources = [
  { title: 'Al Hirschfeld', id: 'hirschfeld', eventColor: 'red' },
  { title: 'August Wilson', id: 'august-wilson', eventColor: 'blue' },
  { title: 'Belasco', id: 'belasco', eventColor: 'green' },
  { title: 'Bernard B. Jacobs', id: 'jacobs', eventColor: 'purple' },
  { title: 'Booth', id: 'booth', eventColor: 'orange' },
  { title: 'Broadhurst', id: 'broadhurst', eventColor: 'teal' },
  { title: 'Ethel Barrymore', id: 'barrymore', eventColor: 'amber' },
  { title: "Eugene O'Neill", id: 'oneill', eventColor: 'pink' },
  { title: 'Gerald Schoenfeld', id: 'schoenfeld', eventColor: 'indigo' },
  { title: 'Gershwin', id: 'gershwin', eventColor: 'lime' },
  { title: 'Helen Hayes', id: 'hayes', eventColor: 'red' },
  { title: 'Imperial', id: 'imperial', eventColor: 'blue' },
  { title: 'Lunt-Fontanne', id: 'lunt-fontanne', eventColor: 'green' },
  { title: 'Lyceum', id: 'lyceum', eventColor: 'purple' },
  { title: 'Majestic', id: 'majestic', eventColor: 'orange' },
  { title: 'Music Box', id: 'music-box', eventColor: 'teal' },
  { title: 'Richard Rodgers', id: 'rodgers', eventColor: 'amber' },
  { title: 'Samuel J. Friedman', id: 'friedman', eventColor: 'pink' },
  { title: 'Studio 54', id: 'studio-54', eventColor: 'indigo' },
  { title: 'Walter Kerr', id: 'walter-kerr', eventColor: 'lime' },
];

export const initialEvents = [
  // Al Hirschfeld Theatre
  {
    id: 'hirschfeld-kinky-boots',
    start: '2017-01-01T00:00:00',
    end: '2019-04-07T00:00:00',
    title: 'Kinky Boots',
    resource: 'hirschfeld',
    allDay: true,
  },
  {
    id: 'hirschfeld-moulin-rouge',
    start: '2019-07-25T00:00:00',
    end: '2026-07-26T00:00:00',
    title: 'Moulin Rouge! The Musical',
    resource: 'hirschfeld',
    allDay: true,
  },
  // August Wilson Theatre
  {
    id: 'august-wilson-mean-girls',
    start: '2018-04-08T00:00:00',
    end: '2020-03-11T00:00:00',
    title: 'Mean Girls',
    resource: 'august-wilson',
    allDay: true,
  },
  {
    id: 'august-wilson-pass-over',
    start: '2021-08-22T00:00:00',
    end: '2021-10-10T00:00:00',
    title: 'Pass Over',
    resource: 'august-wilson',
    allDay: true,
  },
  {
    id: 'august-wilson-funny-girl',
    start: '2022-04-24T00:00:00',
    end: '2023-09-03T00:00:00',
    title: 'Funny Girl',
    resource: 'august-wilson',
    allDay: true,
  },
  {
    id: 'august-wilson-cabaret',
    start: '2024-04-20T00:00:00',
    end: '2025-09-21T00:00:00',
    title: 'Cabaret at the Kit Kat Club',
    resource: 'august-wilson',
    allDay: true,
  },
  // Belasco Theatre
  {
    id: 'belasco-network',
    start: '2018-12-06T00:00:00',
    end: '2019-06-08T00:00:00',
    title: 'Network',
    resource: 'belasco',
    allDay: true,
  },
  {
    id: 'belasco-girl-north-country',
    start: '2020-03-05T00:00:00',
    end: '2022-01-23T00:00:00',
    title: 'Girl from the North Country',
    resource: 'belasco',
    allDay: true,
  },
  {
    id: 'belasco-good-night-oscar',
    start: '2023-04-24T00:00:00',
    end: '2023-08-27T00:00:00',
    title: 'Good Night, Oscar',
    resource: 'belasco',
    allDay: true,
  },
  {
    id: 'belasco-maybe-happy-ending',
    start: '2024-11-12T00:00:00',
    end: '2026-06-30T00:00:00',
    title: 'Maybe Happy Ending',
    resource: 'belasco',
    allDay: true,
  },
  // Bernard B. Jacobs Theatre
  {
    id: 'jacobs-iceman-cometh',
    start: '2018-04-26T00:00:00',
    end: '2018-07-01T00:00:00',
    title: 'The Iceman Cometh',
    resource: 'jacobs',
    allDay: true,
  },
  {
    id: 'jacobs-ferryman',
    start: '2018-10-21T00:00:00',
    end: '2019-07-07T00:00:00',
    title: 'The Ferryman',
    resource: 'jacobs',
    allDay: true,
  },
  {
    id: 'jacobs-betrayal',
    start: '2019-09-05T00:00:00',
    end: '2019-12-08T00:00:00',
    title: 'Betrayal',
    resource: 'jacobs',
    allDay: true,
  },
  {
    id: 'jacobs-company',
    start: '2021-12-09T00:00:00',
    end: '2022-07-31T00:00:00',
    title: 'Company',
    resource: 'jacobs',
    allDay: true,
  },
  {
    id: 'jacobs-almost-famous',
    start: '2022-11-03T00:00:00',
    end: '2023-01-08T00:00:00',
    title: 'Almost Famous',
    resource: 'jacobs',
    allDay: true,
  },
  {
    id: 'jacobs-parade',
    start: '2023-03-16T00:00:00',
    end: '2023-08-06T00:00:00',
    title: 'Parade',
    resource: 'jacobs',
    allDay: true,
  },
  {
    id: 'jacobs-outsiders',
    start: '2024-04-11T00:00:00',
    end: '2026-09-13T00:00:00',
    title: 'The Outsiders',
    resource: 'jacobs',
    allDay: true,
  },
  // Booth Theatre
  {
    id: 'booth-boys-in-band',
    start: '2018-05-31T00:00:00',
    end: '2018-08-11T00:00:00',
    title: 'The Boys in the Band',
    resource: 'booth',
    allDay: true,
  },
  {
    id: 'booth-american-son',
    start: '2018-11-04T00:00:00',
    end: '2019-01-27T00:00:00',
    title: 'American Son',
    resource: 'booth',
    allDay: true,
  },
  {
    id: 'booth-gary',
    start: '2019-04-21T00:00:00',
    end: '2019-06-16T00:00:00',
    title: 'Gary: A Sequel to Titus Andronicus',
    resource: 'booth',
    allDay: true,
  },
  {
    id: 'booth-freestyle-1',
    start: '2019-10-02T00:00:00',
    end: '2020-01-12T00:00:00',
    title: 'Freestyle Love Supreme',
    resource: 'booth',
    allDay: true,
  },
  {
    id: 'booth-freestyle-2',
    start: '2021-10-19T00:00:00',
    end: '2022-01-02T00:00:00',
    title: 'Freestyle Love Supreme',
    resource: 'booth',
    allDay: true,
  },
  {
    id: 'booth-for-colored-girls',
    start: '2022-04-20T00:00:00',
    end: '2022-06-05T00:00:00',
    title: 'for colored girls…',
    resource: 'booth',
    allDay: true,
  },
  {
    id: 'booth-kimberly-akimbo',
    start: '2022-11-10T00:00:00',
    end: '2024-04-28T00:00:00',
    title: 'Kimberly Akimbo',
    resource: 'booth',
    allDay: true,
  },
  {
    id: 'booth-roommate',
    start: '2024-09-12T00:00:00',
    end: '2024-12-15T00:00:00',
    title: 'The Roommate',
    resource: 'booth',
    allDay: true,
  },
  {
    id: 'booth-john-proctor',
    start: '2025-04-14T00:00:00',
    end: '2025-09-07T00:00:00',
    title: 'John Proctor is the Villain',
    resource: 'booth',
    allDay: true,
  },
  // Broadhurst Theatre
  {
    id: 'broadhurst-anastasia',
    start: '2017-04-24T00:00:00',
    end: '2019-03-31T00:00:00',
    title: 'Anastasia',
    resource: 'broadhurst',
    allDay: true,
  },
  {
    id: 'broadhurst-frankie-johnny',
    start: '2019-05-30T00:00:00',
    end: '2019-07-28T00:00:00',
    title: 'Frankie and Johnny in the Clair de Lune',
    resource: 'broadhurst',
    allDay: true,
  },
  {
    id: 'broadhurst-jagged-little-pill',
    start: '2019-12-05T00:00:00',
    end: '2021-12-17T00:00:00',
    title: 'Jagged Little Pill',
    resource: 'broadhurst',
    allDay: true,
  },
  {
    id: 'broadhurst-beautiful-noise',
    start: '2022-12-04T00:00:00',
    end: '2024-06-30T00:00:00',
    title: 'A Beautiful Noise',
    resource: 'broadhurst',
    allDay: true,
  },
  {
    id: 'broadhurst-hills-california',
    start: '2024-09-29T00:00:00',
    end: '2024-12-22T00:00:00',
    title: 'The Hills of California',
    resource: 'broadhurst',
    allDay: true,
  },
  {
    id: 'broadhurst-boop',
    start: '2025-04-05T00:00:00',
    end: '2025-07-13T00:00:00',
    title: 'BOOP! The Musical',
    resource: 'broadhurst',
    allDay: true,
  },
  // Ethel Barrymore Theatre
  {
    id: 'barrymore-bands-visit',
    start: '2017-11-09T00:00:00',
    end: '2019-04-07T00:00:00',
    title: "The Band's Visit",
    resource: 'barrymore',
    allDay: true,
  },
  {
    id: 'barrymore-inheritance',
    start: '2019-11-17T00:00:00',
    end: '2020-03-15T00:00:00',
    title: 'The Inheritance',
    resource: 'barrymore',
    allDay: true,
  },
  {
    id: 'barrymore-waitress',
    start: '2021-09-02T00:00:00',
    end: '2022-01-09T00:00:00',
    title: 'Waitress',
    resource: 'barrymore',
    allDay: true,
  },
  {
    id: 'barrymore-paradise-square',
    start: '2022-04-03T00:00:00',
    end: '2022-07-17T00:00:00',
    title: 'Paradise Square',
    resource: 'barrymore',
    allDay: true,
  },
  {
    id: 'barrymore-piano-lesson',
    start: '2022-10-13T00:00:00',
    end: '2023-01-29T00:00:00',
    title: 'The Piano Lesson',
    resource: 'barrymore',
    allDay: true,
  },
  {
    id: 'barrymore-peter-pan-wrong',
    start: '2023-04-19T00:00:00',
    end: '2023-07-23T00:00:00',
    title: 'Peter Pan Goes Wrong',
    resource: 'barrymore',
    allDay: true,
  },
  {
    id: 'barrymore-harmony',
    start: '2023-11-13T00:00:00',
    end: '2024-02-04T00:00:00',
    title: 'Harmony',
    resource: 'barrymore',
    allDay: true,
  },
  {
    id: 'barrymore-patriots',
    start: '2024-04-22T00:00:00',
    end: '2024-06-23T00:00:00',
    title: 'Patriots',
    resource: 'barrymore',
    allDay: true,
  },
  {
    id: 'barrymore-our-town',
    start: '2024-10-10T00:00:00',
    end: '2025-01-19T00:00:00',
    title: 'Our Town',
    resource: 'barrymore',
    allDay: true,
  },
  {
    id: 'barrymore-othello',
    start: '2025-03-23T00:00:00',
    end: '2025-06-08T00:00:00',
    title: 'Othello',
    resource: 'barrymore',
    allDay: true,
  },
  // Eugene O'Neill Theatre
  {
    id: 'oneill-book-of-mormon',
    start: '2017-01-01T00:00:00',
    end: '2026-06-30T00:00:00',
    title: 'The Book of Mormon',
    resource: 'oneill',
    allDay: true,
  },
  // Gerald Schoenfeld Theatre
  {
    id: 'schoenfeld-come-from-away',
    start: '2017-03-12T00:00:00',
    end: '2022-10-02T00:00:00',
    title: 'Come From Away',
    resource: 'schoenfeld',
    allDay: true,
  },
  {
    id: 'schoenfeld-life-of-pi',
    start: '2023-03-30T00:00:00',
    end: '2023-07-23T00:00:00',
    title: 'Life of Pi',
    resource: 'schoenfeld',
    allDay: true,
  },
  {
    id: 'schoenfeld-notebook',
    start: '2024-03-14T00:00:00',
    end: '2024-12-15T00:00:00',
    title: 'The Notebook',
    resource: 'schoenfeld',
    allDay: true,
  },
  {
    id: 'schoenfeld-buena-vista',
    start: '2025-03-19T00:00:00',
    end: '2026-06-30T00:00:00',
    title: 'Buena Vista Social Club',
    resource: 'schoenfeld',
    allDay: true,
  },
  // Gershwin Theatre
  {
    id: 'gershwin-wicked',
    start: '2017-01-01T00:00:00',
    end: '2026-06-30T00:00:00',
    title: 'Wicked',
    resource: 'gershwin',
    allDay: true,
  },
  // Helen Hayes Theatre
  {
    id: 'hayes-lobby-hero',
    start: '2018-03-26T00:00:00',
    end: '2018-05-13T00:00:00',
    title: 'Lobby Hero',
    resource: 'hayes',
    allDay: true,
  },
  {
    id: 'hayes-straight-white-men',
    start: '2018-07-23T00:00:00',
    end: '2018-09-09T00:00:00',
    title: 'Straight White Men',
    resource: 'hayes',
    allDay: true,
  },
  {
    id: 'hayes-torch-song',
    start: '2018-11-01T00:00:00',
    end: '2019-01-06T00:00:00',
    title: 'Torch Song',
    resource: 'hayes',
    allDay: true,
  },
  {
    id: 'hayes-constitution',
    start: '2019-03-31T00:00:00',
    end: '2019-08-24T00:00:00',
    title: 'What the Constitution Means to Me',
    resource: 'hayes',
    allDay: true,
  },
  {
    id: 'hayes-linda-vista',
    start: '2019-10-10T00:00:00',
    end: '2019-11-10T00:00:00',
    title: 'Linda Vista',
    resource: 'hayes',
    allDay: true,
  },
  {
    id: 'hayes-grand-horizons',
    start: '2020-01-23T00:00:00',
    end: '2020-03-01T00:00:00',
    title: 'Grand Horizons',
    resource: 'hayes',
    allDay: true,
  },
  {
    id: 'hayes-clydes',
    start: '2021-11-23T00:00:00',
    end: '2022-01-16T00:00:00',
    title: "Clyde's",
    resource: 'hayes',
    allDay: true,
  },
  {
    id: 'hayes-take-me-out',
    start: '2022-04-04T00:00:00',
    end: '2022-06-11T00:00:00',
    title: 'Take Me Out',
    resource: 'hayes',
    allDay: true,
  },
  {
    id: 'hayes-kite-runner',
    start: '2022-07-21T00:00:00',
    end: '2022-10-30T00:00:00',
    title: 'The Kite Runner',
    resource: 'hayes',
    allDay: true,
  },
  {
    id: 'hayes-between-riverside',
    start: '2022-12-19T00:00:00',
    end: '2023-02-19T00:00:00',
    title: 'Between Riverside and Crazy',
    resource: 'hayes',
    allDay: true,
  },
  {
    id: 'hayes-thanksgiving-play',
    start: '2023-04-20T00:00:00',
    end: '2023-06-11T00:00:00',
    title: 'The Thanksgiving Play',
    resource: 'hayes',
    allDay: true,
  },
  {
    id: 'hayes-cottage',
    start: '2023-07-24T00:00:00',
    end: '2023-10-29T00:00:00',
    title: 'The Cottage',
    resource: 'hayes',
    allDay: true,
  },
  {
    id: 'hayes-appropriate',
    start: '2023-12-18T00:00:00',
    end: '2024-03-03T00:00:00',
    title: 'Appropriate',
    resource: 'hayes',
    allDay: true,
  },
  {
    id: 'hayes-mother-play',
    start: '2024-04-25T00:00:00',
    end: '2024-06-16T00:00:00',
    title: 'Mother Play',
    resource: 'hayes',
    allDay: true,
  },
  {
    id: 'hayes-job',
    start: '2024-07-30T00:00:00',
    end: '2024-10-27T00:00:00',
    title: 'JOB',
    resource: 'hayes',
    allDay: true,
  },
  {
    id: 'hayes-cult-of-love',
    start: '2024-12-12T00:00:00',
    end: '2025-02-02T00:00:00',
    title: 'Cult of Love',
    resource: 'hayes',
    allDay: true,
  },
  {
    id: 'hayes-purpose',
    start: '2025-03-17T00:00:00',
    end: '2025-08-31T00:00:00',
    title: 'Purpose',
    resource: 'hayes',
    allDay: true,
  },
  // Imperial Theatre
  {
    id: 'imperial-carousel',
    start: '2018-04-12T00:00:00',
    end: '2018-09-16T00:00:00',
    title: 'Carousel',
    resource: 'imperial',
    allDay: true,
  },
  {
    id: 'imperial-aint-too-proud',
    start: '2019-03-21T00:00:00',
    end: '2022-01-16T00:00:00',
    title: "Ain't Too Proud",
    resource: 'imperial',
    allDay: true,
  },
  {
    id: 'imperial-bad-cinderella',
    start: '2023-03-23T00:00:00',
    end: '2023-06-04T00:00:00',
    title: 'Bad Cinderella',
    resource: 'imperial',
    allDay: true,
  },
  {
    id: 'imperial-water-elephants',
    start: '2024-03-21T00:00:00',
    end: '2024-12-08T00:00:00',
    title: 'Water for Elephants',
    resource: 'imperial',
    allDay: true,
  },
  {
    id: 'imperial-smash',
    start: '2025-04-10T00:00:00',
    end: '2025-06-22T00:00:00',
    title: 'Smash',
    resource: 'imperial',
    allDay: true,
  },
  // Lunt-Fontanne Theatre
  {
    id: 'lunt-fontanne-donna-summer',
    start: '2018-04-23T00:00:00',
    end: '2018-12-30T00:00:00',
    title: 'Summer: The Donna Summer Musical',
    resource: 'lunt-fontanne',
    allDay: true,
  },
  {
    id: 'lunt-fontanne-tina',
    start: '2019-11-07T00:00:00',
    end: '2022-08-14T00:00:00',
    title: 'Tina: The Tina Turner Musical',
    resource: 'lunt-fontanne',
    allDay: true,
  },
  {
    id: 'lunt-fontanne-sweeney-todd',
    start: '2023-03-26T00:00:00',
    end: '2024-05-05T00:00:00',
    title: 'Sweeney Todd',
    resource: 'lunt-fontanne',
    allDay: true,
  },
  {
    id: 'lunt-fontanne-death-becomes-her',
    start: '2024-11-21T00:00:00',
    end: '2026-06-30T00:00:00',
    title: 'Death Becomes Her',
    resource: 'lunt-fontanne',
    allDay: true,
  },
  // Lyceum Theatre
  {
    id: 'lyceum-play-goes-wrong',
    start: '2017-04-02T00:00:00',
    end: '2019-01-06T00:00:00',
    title: 'The Play That Goes Wrong',
    resource: 'lyceum',
    allDay: true,
  },
  {
    id: 'lyceum-be-more-chill',
    start: '2019-03-10T00:00:00',
    end: '2019-08-11T00:00:00',
    title: 'Be More Chill',
    resource: 'lyceum',
    allDay: true,
  },
  {
    id: 'lyceum-strange-loop',
    start: '2022-04-26T00:00:00',
    end: '2023-01-15T00:00:00',
    title: 'A Strange Loop',
    resource: 'lyceum',
    allDay: true,
  },
  {
    id: 'lyceum-grey-house',
    start: '2023-06-06T00:00:00',
    end: '2023-07-30T00:00:00',
    title: 'Grey House',
    resource: 'lyceum',
    allDay: true,
  },
  {
    id: 'lyceum-oh-mary',
    start: '2024-07-11T00:00:00',
    end: '2026-06-30T00:00:00',
    title: 'Oh, Mary!',
    resource: 'lyceum',
    allDay: true,
  },
  // Majestic Theatre
  {
    id: 'majestic-phantom',
    start: '2017-01-01T00:00:00',
    end: '2023-04-16T00:00:00',
    title: 'The Phantom of the Opera',
    resource: 'majestic',
    allDay: true,
  },
  {
    id: 'majestic-gypsy',
    start: '2024-12-19T00:00:00',
    end: '2025-08-17T00:00:00',
    title: 'Gypsy',
    resource: 'majestic',
    allDay: true,
  },
  // Music Box Theatre
  {
    id: 'music-box-dear-evan-hansen',
    start: '2017-01-01T00:00:00',
    end: '2022-09-18T00:00:00',
    title: 'Dear Evan Hansen',
    resource: 'music-box',
    allDay: true,
  },
  {
    id: 'music-box-walking-ghosts',
    start: '2022-10-27T00:00:00',
    end: '2022-11-20T00:00:00',
    title: 'Walking with Ghosts',
    resource: 'music-box',
    allDay: true,
  },
  {
    id: 'music-box-dancin',
    start: '2023-03-19T00:00:00',
    end: '2023-05-14T00:00:00',
    title: "Bob Fosse's Dancin'",
    resource: 'music-box',
    allDay: true,
  },
  {
    id: 'music-box-purlie',
    start: '2023-09-27T00:00:00',
    end: '2024-02-04T00:00:00',
    title: 'Purlie Victorious',
    resource: 'music-box',
    allDay: true,
  },
  {
    id: 'music-box-suffs',
    start: '2024-04-18T00:00:00',
    end: '2025-01-05T00:00:00',
    title: 'Suffs',
    resource: 'music-box',
    allDay: true,
  },
  {
    id: 'music-box-dorian-gray',
    start: '2025-03-27T00:00:00',
    end: '2025-06-29T00:00:00',
    title: 'The Picture of Dorian Gray',
    resource: 'music-box',
    allDay: true,
  },
  // Richard Rodgers Theatre
  {
    id: 'rodgers-hamilton',
    start: '2017-01-01T00:00:00',
    end: '2026-06-30T00:00:00',
    title: 'Hamilton',
    resource: 'rodgers',
    allDay: true,
  },
  // Samuel J. Friedman Theatre
  {
    id: 'friedman-the-nap',
    start: '2018-09-27T00:00:00',
    end: '2018-11-11T00:00:00',
    title: 'The Nap',
    resource: 'friedman',
    allDay: true,
  },
  {
    id: 'friedman-choir-boy',
    start: '2019-01-22T00:00:00',
    end: '2019-03-10T00:00:00',
    title: 'Choir Boy',
    resource: 'friedman',
    allDay: true,
  },
  {
    id: 'friedman-ink',
    start: '2019-04-24T00:00:00',
    end: '2019-07-07T00:00:00',
    title: 'Ink',
    resource: 'friedman',
    allDay: true,
  },
  {
    id: 'friedman-height-of-storm',
    start: '2019-09-24T00:00:00',
    end: '2019-11-24T00:00:00',
    title: 'The Height of the Storm',
    resource: 'friedman',
    allDay: true,
  },
  {
    id: 'friedman-lucy-barton',
    start: '2020-01-15T00:00:00',
    end: '2020-02-29T00:00:00',
    title: 'My Name Is Lucy Barton',
    resource: 'friedman',
    allDay: true,
  },
  {
    id: 'friedman-lackawanna',
    start: '2021-10-07T00:00:00',
    end: '2021-11-12T00:00:00',
    title: 'Lackawanna Blues',
    resource: 'friedman',
    allDay: true,
  },
  {
    id: 'friedman-skeleton-crew',
    start: '2022-01-12T00:00:00',
    end: '2022-02-20T00:00:00',
    title: 'Skeleton Crew',
    resource: 'friedman',
    allDay: true,
  },
  {
    id: 'friedman-how-i-learned',
    start: '2022-04-19T00:00:00',
    end: '2022-06-12T00:00:00',
    title: 'How I Learned to Drive',
    resource: 'friedman',
    allDay: true,
  },
  {
    id: 'friedman-cost-of-living',
    start: '2022-10-03T00:00:00',
    end: '2022-11-06T00:00:00',
    title: 'Cost of Living',
    resource: 'friedman',
    allDay: true,
  },
  {
    id: 'friedman-summer-1976',
    start: '2023-04-25T00:00:00',
    end: '2023-06-18T00:00:00',
    title: 'Summer, 1976',
    resource: 'friedman',
    allDay: true,
  },
  {
    id: 'friedman-prayer-french',
    start: '2024-01-09T00:00:00',
    end: '2024-03-03T00:00:00',
    title: 'Prayer for the French Republic',
    resource: 'friedman',
    allDay: true,
  },
  {
    id: 'friedman-mary-jane',
    start: '2024-04-23T00:00:00',
    end: '2024-06-30T00:00:00',
    title: 'Mary Jane',
    resource: 'friedman',
    allDay: true,
  },
  // Studio 54
  {
    id: 'studio-54-lifespan-fact',
    start: '2018-10-18T00:00:00',
    end: '2019-01-13T00:00:00',
    title: 'The Lifespan of a Fact',
    resource: 'studio-54',
    allDay: true,
  },
  {
    id: 'studio-54-kiss-me-kate',
    start: '2019-03-14T00:00:00',
    end: '2019-06-30T00:00:00',
    title: 'Kiss Me, Kate',
    resource: 'studio-54',
    allDay: true,
  },
  {
    id: 'studio-54-sound-inside',
    start: '2019-10-17T00:00:00',
    end: '2020-01-12T00:00:00',
    title: 'The Sound Inside',
    resource: 'studio-54',
    allDay: true,
  },
  {
    id: 'studio-54-caroline',
    start: '2021-10-27T00:00:00',
    end: '2022-01-09T00:00:00',
    title: 'Caroline, or Change',
    resource: 'studio-54',
    allDay: true,
  },
  {
    id: 'studio-54-minutes',
    start: '2022-04-17T00:00:00',
    end: '2022-07-24T00:00:00',
    title: 'The Minutes',
    resource: 'studio-54',
    allDay: true,
  },
  {
    id: 'studio-54-pictures',
    start: '2023-02-09T00:00:00',
    end: '2023-04-30T00:00:00',
    title: 'Pictures from Home',
    resource: 'studio-54',
    allDay: true,
  },
  {
    id: 'studio-54-days-wine',
    start: '2024-01-28T00:00:00',
    end: '2024-03-31T00:00:00',
    title: 'Days of Wine and Roses',
    resource: 'studio-54',
    allDay: true,
  },
  {
    id: 'studio-54-wonderful-world',
    start: '2024-11-11T00:00:00',
    end: '2025-02-23T00:00:00',
    title: 'A Wonderful World',
    resource: 'studio-54',
    allDay: true,
  },
  // Walter Kerr Theatre
  {
    id: 'walter-kerr-springsteen',
    start: '2017-10-12T00:00:00',
    end: '2018-12-15T00:00:00',
    title: 'Springsteen on Broadway',
    resource: 'walter-kerr',
    allDay: true,
  },
  {
    id: 'walter-kerr-hadestown',
    start: '2019-04-17T00:00:00',
    end: '2026-06-30T00:00:00',
    title: 'Hadestown',
    resource: 'walter-kerr',
    allDay: true,
  },
];
